<div id="content" class="allcp-form map-content" ng-controller="RouteController" ng-init="init()">
    <div ng-include="'modules/company/menus/order_menu.html'"></div>
    <div class="row">
        <div id="map" class="route-map" ng-click="clearMap()"></div>
        <div ng-include="'modules/company/routing/route_sidebar.html'"></div>
        <a href="#" class="map-button hod-button blue" ng-if="!editMode" ng-click="editRoute()">Edit Routes</a>
        <a href="#" class="map-button hod-button blue" ng-if="editMode" ng-click="closeEditRoute()">Close Edit Mode</a>
        <a href="#" class="map-button hod-button" ng-click="openOptimize()" style="margin-top: 64px;">Create Route</a>

        <div ng-if="selectedForEditOrder.length > 0" class="selectedOrders" style="margin-top: 128px;"">
            <div class="form-group floating">
                <select class="selectpicker" 
                    title="Routes"
                    style="width:100%"
                    data-selected-text-format="count" 
                    data-language="tr_TR"
                    ng-model="route_id"
                    data-style="btn-primary">
                    <option ng-repeat="item in data.routes" 
                        data-select-watcher 
                        data-last="{{$last}}" 
                        class="color-{{ item.color.substring(1) }}"
                        value="{{item.id}}">
                        {{item.unique}}
                    </option>
                </select>
                <label>Routes</label>
            </div>

            <div class="form-group">
                <a href="#" class="hod-button blue" ng-click="assignOrderToRoute(route_id)">
                    <i ng-if="optimizationSpinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i> Assign Order(s) To Route
                </a>
            </div>
            
            <ul class="list-group">
                <li class="list-group-item" ng-repeat="item in selectedForEditOrder">#{{ item.id }} - {{ item.location.name }}</li>
            </ul>
        </div>
    </div>

    <!-- Optimize route -->
    <div class="modal right fade" id="optimizeRouteOld" tabindex="-1" role="dialog" aria-labelledby="routeDetailLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header hide-print">
                    <div class="modal-title">
                        <h4 id="orderDetailLabel">Create Route</h4>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <i class="icon-close-circle"></i>
                    </button>
                </div>

                <form ng-submit="createRoute()">

                    <div class="modal-body order-detail-page">
                        <div class="modal-body-container">
                            <div class="row mt10">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="control-label">Type</label> <br>
                                        <div class="radio-custom radio-primary pln radio-inline mb5 mln" >
                                            <input type="radio" id="distance" value="1" name="type" ng-model="optimize.optimizeBy">
                                            <label for="distance">Distance</label>
                                        </div>
                                        <div class="radio-custom radio-primary pln radio-inline mb5 mln" >
                                            <input type="radio" id="time" value="2" name="type" ng-model="optimize.optimizeBy">
                                            <label for="time">Time</label>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Number of Routes</label> <br>
                                        <input type="number" class="form-control" ng-model="optimize.count" required>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Stop Time (in Minutes)</label> <br>
                                        <input type="number" class="form-control" ng-model="optimize.stop_time" required>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Scheduled</label> <br>
                                        <input id="datetimepicker" 
                                            date-range-picker
                                            type="text" 
                                            class="form-control input-md" 
                                            ng-model="optimize.scheduled"
                                            options="{timePicker: true, autoApply: true, locale: { format: 'MM/DD hh:mm A' } }"
                                            required
                                            autocomplete="off">
                                    </div>
                                    <!-- <div class="form-group">
                                        <label class="control-label">Travel Mode</label> <br>
                                        <select 
                                            ng-model="optimize.mode"
                                            ng-init="optimize.mode = 'Driving'"
                                            class="form-control">
                                            <option value="Driving">Driving</option>
                                            <option value="Walking">Walking</option>
                                            <option value="Bicycling">Bicycling</option>
                                        </select>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer bg-light">
                        <button type="submit" class="btn pull-left btn-primary"><i ng-if="optimizationSpinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i> Optimize</button>
                        <button type="button" class="btn pull-left btn-default" data-dismiss="modal" data-toggle="modal">Cancel</button>
                    </div>
                    
                </form>
            </div>
        </div>
    </div>

    <!-- Asssign route -->
    <div class="modal right fade" id="assignToWorkerRoute" tabindex="-1" role="dialog" aria-labelledby="routeDetailLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="routeDetailLabel">Assign To Rider!</h4>
                </div>
                <div class="modal-body">

                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label class="control-label">Please Select Rider:</label><br>
                                <select class="ml10 form-control" 
                                    title="Rider"
                                    ng-model="worker_id">
                                    <option ng-repeat="item in data.workers" value="{{item.id}}">{{item.full_name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer bg-light">
                    <button type="submit" class="btn pull-left btn-primary" ng-click="assignToWorker(worker_id)"><i ng-if="optimizationSpinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i> Assign</button>
                    <button type="button" class="btn pull-left btn-default" data-dismiss="modal" data-toggle="modal">Cancel</button>
                </div>
            </div>
        </div>
    </div>

    <!-- New Route -->
    <div class="modal right" id="optimizeRoute" tabindex="-1" role="dialog" aria-labelledby="optimizeRouteLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content" id="print-content">
                <div class="modal-header hide-print">
                    <div class="modal-title">
                        <h4 id="optimizeRouteLabel" ng-if="!route.id">New Route</h4>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <i class="icon-close-circle"></i>
                    </button>
                </div>
                <div class="modal-body order-detail-page">
                    <div class="modal-body-container">
                        <div class="tab-content">
                            <div class="tab-pane active">
                                <div class="row">
                                    <div class="col-md-12">
                                        <form ng-submit="createRoute()" class="form-horizontal allcp-form">

                                            <div class="form-group floating">
                                                <input id="datetimepicker" 
                                                    date-range-picker
                                                    placeholder="Date" 
                                                    ng-model="newRouteData.date"
                                                    type="text" 
                                                    class="form-control  input-md" 
                                                    options="{drops: 'down', singleDatePicker: true, locale: { format: 'MM/DD/YYYY' } }"
                                                    autocomplete="off"
                                                    required>
                                                <label>Date</label>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-6 pl15">
                                                    <div class="form-group floating">
                                                        <input id="startrt" autocomplete="off" type="text" class="form-control input-md" placeholder="Start Time" required ng-model="newRouteData.scheduled_start">
                                                        <label>Start Time</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 pr10">
                                                    <div class="form-group floating">
                                                        <input id="endrt" autocomplete="off" type="text" class="form-control input-md" placeholder="End Time" required ng-model="newRouteData.scheduled_end">
                                                        <label>End Time</label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group floating mt-2">
                                                <div>
                                                    <select id="type" autocomplete="off" class="form-control input-md" name="type" ng-model="newRouteData.station_id" required>
                                                        <option value="">Select Station</option>
                                                        <option value="{{ item.id }}" ng-repeat="item in rtstations">{{ item.code }} - {{ item.city }}</option>
                                                    </select>
                                                    <label>Station</label>
                                                </div>
                                            </div>

                                            <div class="form-group floating">
                                                <input autocomplete="off" type="number" class="form-control input-md" placeholder="Service Time" required ng-model="newRouteData.stop_time">
                                                <label>Service Time</label>
                                            </div>

                                            <div class="form-group floating">
                                                <select id="type" name="type" ng-model="newRouteData.vehicle" class="form-control input-md">
                                                    <option value="">Select Vehicle</option>
                                                    <option value="Small">Small</option>
                                                    <option value="Medium">Medium</option>
                                                    <option value="Large">Large</option>
                                                </select>
                                                <label>
                                                    Wehicle
                                                </label>
                                            </div>
                    
                                            <div class="form-group floating pln">
                                                <div class="col-md-12 pln">
                                                    <button type="submit" class="hod-button blue">
                                                        <span ng-if="!route.id">CREATE</span>
                                                        <span ng-if="route.id">UPDATE</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    html, body {
        height:100% !important;
    }
</style>
<script>
    $(document).ready(function(){
    var height = $(window).height() - 116;
    $('.map-content').css('height',height);
        $(window).resize(function(){
        var height = $(window).height() - 116;
        $('.map-content').css('height',height);
        });
    });
</script>